<template>
<div class="search-filters led-alt-filter">
    <div class="head">
        <span>{{ $t('alt_filters_filter') }}</span>
        <div class="reset" v-if="Object.keys(filters).length > 0" @click='clearFilters()'>
            <span>{{$t('search_filters_reset')}}</span>
        </div>
        <div class="expand" :class="{open: filtersOpen}">
            <img src="@/assets/svg/caret.svg" alt="" @click="toggleFilterList">
        </div> 
    </div>
    <div class="all-filters" :class="{open: filtersOpen}">
        <div class="filter-selector" v-for="(facet, key) in buildLedAltFilterList" :key="key">
            <div class="filter">
                <!-- Filter header -->
                <div class="filter-name" :id="`filter-name-${facet.name}`" @click="toggleFilter(facet.name)" :class="{ 'open': currentOpenFilter === facet.name, 'active': hasActiveFilter(facet.name) }">
                    <span>
                        {{ $t(facet.name) }} 
                    </span>
                </div>

                <!-- Filter values -->
                <div class="filter-values" v-if="currentOpenFilter === facet.name">
                    <div class="custom-control custom-checkbox" v-for="(item, index) in facet.values" :key="index">
                        <input type="checkbox" class="custom-control-input" :id="item.value" @click="setFilter(item, facet.name)" :checked="isValueChecked(item.value, facet.name)" />
                        <label class="custom-control-label font-resp" :for="item.value">{{item.value}}</label>
                    </div>
                </div>
            </div>
            
        </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'AlternativeFilters',
  components: {},

  data() {
    return {
        filtersOpen: false,
        currentOpenFilter: '',
    };
  },

  computed: {

    matches() {
        return this.$store.state.search.results[this.$store.state.search.selectedResult].matches.map(e => e.match);
    },
    
    buildLedAltFilterList() {
        const matches = this.matches;
        const filterOptionsAlts = this.$store.state.search.filterOptionsAlts;
        const tempFilterList = [];

        for (let opt of filterOptionsAlts) {
            const values = [];

            for (let item of matches) {
                if (item.hasOwnProperty(opt)) {
                    const value = item[opt];
                    const existingValue = values.find(v => v.value === value);
                    if (existingValue) {
                        existingValue.count++;
                    } else {
                        values.push({
                            value: value,
                            count: 1,
                            selected: false
                        });
                    }
                }
            }

            if (values.length > 0) {
                if (opt === "lifetime") {
                    tempFilterList.push({
                        name: opt,
                        values: this.sortLifetimeValues(values)
                    });
                } else if (opt === "tiering") {
                    tempFilterList.push({
                        name: opt,
                        values: this.sortTieringValues(values)
                    });
                } else {
                    tempFilterList.push({
                        name: opt,
                        values: values
                    });
                }
            }
        }

        this.$store.dispatch('search/setFilterAltList', tempFilterList);
        return tempFilterList;
    },

    filters() {
        return this.$store.state.search.matchesFilters;
    },
  },

  methods: {
    isValueChecked(value, filterName) {
        if (this.filters && this.filters.hasOwnProperty(filterName))
            return this.filters[filterName].indexOf(value) !== -1;
    },

    sortLifetimeValues(values) {
        let lifetimeValues = []; 
        let sortedLifetimeValues = [];
        for(let item of values) 
            lifetimeValues.push(parseInt(item.value.replace('hrs', '')));

        lifetimeValues.sort((a, b) => a - b);

        for(let item of lifetimeValues) {
            sortedLifetimeValues.push ({
                value: item.toString() + 'hrs',
                selected: false
            });
        }

        return sortedLifetimeValues;
    },

    sortTieringValues(values) {
        console.log(values);

        const order = [
            "MasterConnect",
            "MASTER",
            "MASTER Value",
            "CorePro",
            "Ecofit"
        ];

        function compare(a, b) {
            let aIndex = order.indexOf(a.value);
            let bIndex = order.indexOf(b.value);
            if (aIndex == -1)
                aIndex = 999;
            if (bIndex == -1)
                bIndex = 999;
            return aIndex - bIndex;
        }

        return values.sort(compare);
    },

    toggleFilterList() {
        this.filtersOpen = !this.filtersOpen;
    },
    toggleFilter(filterName) {
        if (filterName === this.currentOpenFilter) {
            this.closeFilter();
        } else {
            this.currentOpenFilter = filterName;
        }
    },

    hasActiveFilter(filter) {
        const selectedFilters = this.filters;

        return (selectedFilters && selectedFilters.hasOwnProperty(filter) && selectedFilters[filter].length > 0)
    },

    closeFilter() {
        this.currentOpenFilter = "";
        window.removeEventListener('click', this.closeClickHandler);
    },

    closeClickHandler(event) {
        const trigger = document.querySelector(`#filter-name-${this.currentOpenFilter}`);
        const dropdownElement = document.querySelector('.filter-values');

        // Safeguard against interacting with non-existent components
        if (!trigger)
        {
            this.closeFilter();
            return;
        }

        // clicks on the trigger are handled outside of this function
        if(trigger.contains(event.target))
            return;

        if (!dropdownElement.contains(event.target)) {
            this.closeFilter();
        }
    },

    // Triggers when we click on checkbox values
    setFilter(item, filterName) {
        const selectedFilters = this.filters;
        this.updateSelectedFilters(selectedFilters, item.value, filterName);

        this.$store.dispatch('search/setMatchesFilters', selectedFilters);
        this.$store.dispatch('search/setResultFilters', selectedFilters);
    },

    // Update selected filters list by removing or adding filter values to the list
    updateSelectedFilters(selectedFilters, item, filterName) {
        if (!selectedFilters.hasOwnProperty(filterName))
            selectedFilters[filterName] = [];

        const findIndex = selectedFilters[filterName].findIndex(v => v === item);

        if (findIndex === -1) {
            selectedFilters[filterName].push(item);
        }
        else {
            selectedFilters[filterName].splice(findIndex, 1);
        }
    },

    clearFilters() {
        this.$store.dispatch('search/setMatchesFilters', {});
    }
  }
};


</script>

<style>
.led-alt-filter {
    margin-top: 1rem;
}
</style>
